import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 151 179"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-opacity": ".8",
      d: "M150.456 50.52v84.734L77.21 178.551c-1.742 1.027-3.956-.226-3.956-2.244V89.572L1.281 47.022c-1.708-1.01-1.708-3.48 0-4.49L73.254 0l73.002 43.141a8.56 8.56 0 0 1 4.2 7.379"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M73.254 0v89.572L1.281 47.022c-1.708-1.01-1.708-3.48 0-4.49zM150.455 135.219v.035L77.21 178.552c-1.743 1.027-3.956-.226-3.956-2.245V89.572z"
    }, null, -1)
  ])))
}
export default { render: render }